import getNested from "lodash-es/get";
import Vue from "vue";
import Vuex from "vuex";
import sortBy from "lodash-es/sortBy";

Vue.use(Vuex);

const baseUrl = process.env.VUE_APP_API_BETA;

export default {
  namespaced: true,
  modules: {
    // polygons: PolygonsStore,
  },

  state: () => {
    return {
      commodities: null,
    };
  },

  mutations: {
    setStateValue(state, { name, value }) {
      state[name] = value;
    },
  },

  actions: {
    async listOrgs({ dispatch }, parameters) {
      let response = await dispatch("apiRequest", {
        method: "get",
        path: "/orgs",
        data: parameters,
      });

      return response.data;
    },

    async getOrg({ dispatch }, parameters) {
      let response = await dispatch("apiRequest", {
        method: "get",
        path: "/orgs/" + parameters.orgId,
        //data: parameters,
      });

      return response.data;
    },

    async updateOrg({ dispatch }, parameters) {
      let response = await dispatch("apiRequest", {
        method: "put",
        path: "/orgs/",
        data: parameters,
      });

      if(response.error) {
        console.log('api error', response);
        return response;
      }

      return getNested(response, 'data', null);
    },

    async deleteOrg({ dispatch }, organizationId) {
      let response = await dispatch("apiRequest", {
        method: "delete",
        path: `/orgs/${organizationId}`,
      });

      if(response.error) {
        return response;
      }

      return getNested(response, 'data', {});
    },

    async listUsersForOrg({ dispatch }, parameters) {
      let response = await dispatch("apiRequest", {
        method: "get",
        path: "/users",
        data: parameters,
      });

      return response.data;
    },

    async getUser({ dispatch }, parameters) {
      let response = await dispatch("apiRequest", {
        method: "get",
        path: "/users/" + parameters.orgId + "/" + parameters.userId,
        //data: parameters,
      });

      return response.data;
    },

    async uploadUsers({dispatch}, parameters) {
      let response = await dispatch('apiRequest', {
        method: 'post',
        path: '/users/bulk',
        data: parameters,
      });

      if(response.error) {
        console.error(response);
        return response;
      }
      return getNested(response, 'data');
    },

    async createOrg({ dispatch }, parameters) {
      let response = await dispatch("apiRequest", {
        method: "post",
        path: "/orgs",
        data: parameters,
      });

      return response.data;
    },

    async updateTrial({ dispatch }, parameters) {
      let response = await dispatch("apiRequest", {
        method: "post",
        path: "/orgs/update_trial",
        data: parameters,
      });

      return response.data;
    },

    async updateRoles({ dispatch }, parameters) {
      let response = await dispatch("apiRequest", {
        method: "post",
        path: "/orgs/update_roles",
        data: parameters,
      });

      if(response.error) {
        return response;
      }

      return response.data;
    },

    async apiRequest(store, parameters) {
      // here you can override common API request parameters for this api module
      // for example:
      // parameters: {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL},
      return store.dispatch(
        "apiRequest",
        { ...parameters, baseUrl },
        { root: true }
      );
    },
  },
};
